import { omitEmptyValue } from "@/utils/utils";
import {  ReportParams } from '@/component/common/report/report'
import { CustomReportConfig, LineChartModule, TableModule } from "@/component/common/report/reportConfigModel";
type ConvertSortParams<T> = {
  [K in keyof T]: string
};
export const convertSortParams = <T extends ReportParams>(params:T)=>{
  let sortFields = (params.sortParams || [])
  delete params.sortParams
  if(sortFields.length == 0){
    return params as ConvertSortParams<T>
  }
  sortFields = sortFields.filter(item => item.order)
  let orderBy = sortFields.map(item=>{
    return item.dataIndex + ' ' + convertSortValues(item.order)
  })
  let newParams = {
    ...params,
    orderBy: orderBy.join(',')
  } 
  delete newParams.sortParams
  return omitEmptyValue(newParams) as ConvertSortParams<T>
}

const sortMethodMap = {
  'asc':'ascend',
  'ascend':'asc',
  'desc':'descend',
  'descend':'desc',
}
export const convertSortValues = (sort:keyof typeof sortMethodMap | undefined | null)=>{
  if(!sort){
    return null
  }
  return sortMethodMap[sort]
}


export enum CountType {
  isRequestTable = 0,  //只有list数据
  isRequestAll = 1,  /// list加count
  isRequestCount = 2 // 只有count
}


export type TableBaseParamsType = {report?:string,source?:string,source_count?:string, template_code?:string}

export const isValidTableBaseParams = (tableBaseParams: TableBaseParamsType):tableBaseParams is Required<TableBaseParamsType>=>{
  const { source, template_code, report } = tableBaseParams
  if(!source || !template_code || !report ){
    console.error(`tableBaseParamsRef 缺少参数`)
    return false
  }
  return true

}


export const getModuleSource = (config:CustomReportConfig|undefined)=>{
  let sourceInfo:Pick<TableModule,'source'|'source_count'|'template_code'> = {
    source:'',  
    source_count: undefined,
    template_code:'',
  }
  if(!config){
    return sourceInfo
  }

  let tableModule = config.modules.find(item => item.type == 'table') as  TableModule
  if(tableModule){
    sourceInfo.source = tableModule.source
    sourceInfo.source_count = tableModule.source_count
    sourceInfo.template_code = tableModule.template_code
    return sourceInfo
  }
  let lineChartModule = config.modules.find(item => item.type == 'lineChart') as  LineChartModule
  if(lineChartModule){
    sourceInfo.source = lineChartModule.source
    sourceInfo.template_code = lineChartModule.template_code
    return sourceInfo
  }
  return sourceInfo
}
export const getSource = (config:CustomReportConfig|undefined)=>{
  let sourceObj = getModuleSource(config);
  if(config && config.alertMenu){
    sourceObj.source = config.alertMenu.menu[0].key
  }
  return {
    ...sourceObj,
    menuItem: config && config.alertMenu?.menu[0]
  }
}
